var _defs, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRetroviseurRepare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 3000 3000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#5a6168;}.cls-4{fill:#868d93;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1194.61,1322.58s7.12-49.78,11.18-57.91,5.08-13.2,21.33-14.22,62-4.06,70.1-3,19.3,8.13,24.38,20.32,19.3,55.87,22.35,58.92,8.12,13.21,16.25,8.13c3-10.16,9.14-14.23,16.25-14.23s17.27,2,21.34,5.08,10.16,6.1,13.2,10.16,4.07,33.53,0,39.62-3,10.16-14.22,11.18-154.41,3-165.58,0S1192.58,1377.43,1194.61,1322.58Z"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "illustration 1 r\xE9troviseur cass\xE9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_9",
    "data-name": "Calque 9"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1,
    y: 1,
    width: 2999,
    height: 2999
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "\\xE9l\\xE9ments_cliquables",
    "data-name": "\\xE9l\\xE9ments cliquables"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1194.61,1322.58s7.12-49.78,11.18-57.91,5.08-13.2,21.33-14.22,62-4.06,70.1-3,19.3,8.13,24.38,20.32,19.3,55.87,22.35,58.92,8.12,13.21,16.25,8.13c3-10.16,9.14-14.23,16.25-14.23s17.27,2,21.34,5.08,10.16,6.1,13.2,10.16,4.07,33.53,0,39.62-3,10.16-14.22,11.18-154.41,3-165.58,0S1192.58,1377.43,1194.61,1322.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1311.27,1254s-86.18,1.58-91.26,5.64-26.41,69.08-11.17,115.81c3.68,11.31-40.64-41.65-40.64-41.65l33.53-96.51h117.84Z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Calque_8",
    "data-name": "Calque 8"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 2999,
    height: 2999
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetroviseurRepare);
export default __webpack_public_path__ + "static/media/retroviseur_repare.d34b7790d441fd9cce76b2fcc2b6e3df.svg";
export { ForwardRef as ReactComponent };